<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.356"
      height="19.928"
      viewBox="0 0 21.356 19.928"
      class="scaling-svg"
    >
      <g id="Group_249" data-name="Group 249" transform="translate(-51 -639.038)">
        <g id="Group_103" data-name="Group 103" transform="translate(0 32.966)">
          <g id="Icon_mail" transform="translate(51.483 614.038)">
            <path
              id="Shape"
              d="M15.3,12H1.7A1.709,1.709,0,0,1,0,10.285V1.714A1.709,1.709,0,0,1,1.7,0H15.3A1.709,1.709,0,0,1,17,1.714v8.571A1.709,1.709,0,0,1,15.3,12ZM1.7,2.725v6.7a.854.854,0,0,0,.85.857h11.9a.854.854,0,0,0,.85-.857v-6.7L8.5,7.011ZM3.3,1.714,8.5,4.989l5.2-3.275Z"
              transform="translate(-0.483 -0.038)"
              fill="#534d69"
            />
          </g>
          <g id="Group_16" data-name="Group 16" transform="translate(40.073 604.645)">
            <circle id="Oval" cx="6.928" cy="6.928" r="6.928" transform="translate(18.427 1.427)" fill="#d60173" />
          </g>
        </g>
        <g id="Group_104" data-name="Group 104" transform="translate(-436.489 1156.885) rotate(-45)">
          <path
            id="Fill_1"
            data-name="Fill 1"
            d="M.09.09a.308.308,0,0,0,0,.436l3.7,3.7a.308.308,0,0,0,.436-.436L.527.09A.308.308,0,0,0,.09.09Z"
            transform="translate(714 -8.5)"
            fill="#fff"
            stroke="#fff"
            stroke-width="0.5"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CancelledIcon extends Vue {}
</script>

<style>
</style>
